import { Container, Row, Col, Alert, Card } from 'react-bootstrap';
import { useLoyalty } from '../../../../apps/hooks/loyalty/useLoyalty';
import { TierManagementEnhanced } from '../components';

export default function TierManagementPage() {
  const {
    tierDefinitions,
    isLoadingTiers,
    isCreatingTier,
    isUpdatingTierDefinition,
    isDeletingTierDefinition,
    error,
    createTier,
    updateTierDefinition,
    deleteTierDefinition,
    clearError,
  } = useLoyalty();

  return (
    <Container fluid className="p-4">
      <Row>
        <Col>
          <div className="mb-4">
            <h1>Tier Management</h1>
            <p className="text-muted">Configure and manage loyalty program tier definitions</p>
          </div>

          {error && (
            <Alert variant="danger" dismissible onClose={clearError}>
              {error}
            </Alert>
          )}

          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Tier Overview</Card.Title>
              <p className="text-muted mb-0">
                Tiers define different levels in your loyalty program. Each tier has minimum point requirements, benefits,
                and display settings. Customers are automatically upgraded to higher tiers as they accumulate points.
              </p>
            </Card.Body>
          </Card>

          <TierManagementEnhanced
            tiers={tierDefinitions || []}
            isLoading={isLoadingTiers}
            onCreateTier={createTier}
            onUpdateTier={updateTierDefinition}
            onDeleteTier={deleteTierDefinition}
            isCreating={isCreatingTier}
            isUpdating={isUpdatingTierDefinition}
            isDeleting={isDeletingTierDefinition}
          />
        </Col>
      </Row>
    </Container>
  );
}

